import { render, staticRenderFns } from "./UploadThumbnail.vue?vue&type=template&id=79af785a"
import script from "./UploadThumbnail.vue?vue&type=script&lang=ts"
export * from "./UploadThumbnail.vue?vue&type=script&lang=ts"
import style0 from "./UploadThumbnail.vue?vue&type=style&index=0&id=79af785a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports